import Close from '@ixigo/icons/Close';
import Typography from '@ixigo/iui/Typography';
import { useState } from 'react';
import type { ChangeEvent } from 'react';
import SearchInput from './SearchInput';
import type { SearchFilterProps } from './types';

const SearchFilter = (props: SearchFilterProps) => {
	const { heading, onClose, placeholder, onFilterChange, className } = props;
	const [value, setValue] = useState<string>('');

	const onChange = (e: ChangeEvent<HTMLInputElement>) => {
		const value = e.target.value;
		setValue(value);
		onFilterChange(value);
	};

	return (
		<div className={className}>
			<div className="sticky top-0 z-50 bg-white">
				<div className="flex justify-between pt-15">
					{heading && (
						<Typography variant="body-md" fontWeight="medium">
							{heading}
						</Typography>
					)}
					{onClose && <Close onClick={onClose} className="cursor-pointer" />}
				</div>
				<SearchInput value={value} onChange={onChange} placeholder={placeholder} />
			</div>
		</div>
	);
};

export default SearchFilter;
